// @ts-strict-ignore
import type { IsolatedEditingBlockOrigin } from '../types';
import { MLAAttributeItemOrigin } from '../types';

export const isMLAAttributeItemOrigin = (origin: IsolatedEditingBlockOrigin) => (
  Object.values(MLAAttributeItemOrigin).includes(origin)
);
